module.exports = __webpack_public_path__ + "img/golden_logo.fb821f40.png";